module.exports = __webpack_public_path__ + "static/hero.a42fc897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.png
// module id = 948
// module chunks = 35783957827783